import { useCallback } from "react";
import type { TFunction } from "i18next";
import { fetchPersonalUpcoming, getCachedPersonalUpcoming } from "../api/dashboard.api";
import type { DashboardPermissions } from "../types/dashboard.types";
import { useCachedDashboardQuery } from "./useCachedDashboardQuery";

export const usePersonalUpcoming = (permissions: DashboardPermissions, t: TFunction) => {
  const fetcher = useCallback(
    (force?: boolean) =>
      fetchPersonalUpcoming(
        {
          canSeeMyEnvironment: permissions.canSeeMyEnvironment,
          canLoadPersonalCalendar: permissions.canLoadPersonalCalendar,
          canViewMyParentMeetings: permissions.canViewMyParentMeetings,
        },
        {
          schoolCalendar: t("dashboard.personal.schoolCalendar", { defaultValue: "School calendar" }),
          agendaActivities: t("dashboard.myEnvironment.agendaActivities", { defaultValue: "Agenda & activities" }),
          parentMeetings: t("dashboard.myEnvironment.parentMeetings", { defaultValue: "Parent meetings" }),
          parentMeetingWithChild: (child) =>
            t("dashboard.personal.parentMeetingWithChild", {
              defaultValue: "Parent meeting - {{child}}",
              child,
            }),
          untitled: t("schoolCalendar.untitled", { defaultValue: "Untitled" }),
        },
        force,
      ),
    [permissions.canLoadPersonalCalendar, permissions.canSeeMyEnvironment, permissions.canViewMyParentMeetings, t],
  );
  return useCachedDashboardQuery(permissions.canSeeMyEnvironment, getCachedPersonalUpcoming, fetcher);
};
